import { Badge } from "antd";
import {
  candidatesStatusList,
  candidateStatusOption,
} from "../help-service/enumList";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { fileTypes } from "../constants/constants";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export const renderCandidateStatus = (status) => {
  switch (status) {
    case 1:
      return <Badge className="badge-r1">R1</Badge>;
    case 2:
      return <Badge className="badge-s">S</Badge>;
    case 3:
      return <Badge className="badge-sh">SH</Badge>;
    case 4:
      return <Badge className="badge-re">NS</Badge>;
    case 5:
      return <Badge className="badge-oh">OH</Badge>;
    case 6:
      return <Badge className="badge-ns">NS</Badge>;
    case 7:
      return <Badge className="badge-w">W</Badge>;
    case 8:
      return <Badge className="badge-ps">PS</Badge>;
    case 9:
      return <Badge className="badge-rs">RS</Badge>;
    case 10:
      return <Badge className="badge-j">J</Badge>;
    case 11:
      return <Badge className="badge-psr">RPS</Badge>;
    default:
      break;
  }
  return;
};

export const renderPSStatus = (status) => {
  switch (status) {
    case 1:
      return <Badge className="badge-ps-scheduled">S</Badge>;
    case 2:
      return <Badge className="badge-ps-completed">C</Badge>;
    case 3:
      return <Badge className="badge-ps-rescheduled">RS</Badge>;
    case 4:
      return <Badge className="badge-ps-partially-completed">PC</Badge>;
    case 5:
      return <Badge className="badge-ps-declined">D</Badge>;
    case 6:
      return <Badge className="badge-ps-not-scheduled">NS</Badge>;
    default:
      break;
  }
  return;
};

export const renderPSStatusBadge = (status) => {
  switch (status) {
    case 1:
      return <div className="pre-status scheduled">Scheduled</div>;
    case 2:
      return <div className="pre-status completed">Completed</div>;
    case 3:
      return <div className="pre-status rescheduled">Rescheduled</div>;
    case 4:
      return <div className="pre-status partially-completed">Partially Completed</div>;
    case 5:
      return <div className="pre-status declined">Declined</div>;
    case 6:
      return <div className="pre-status not-scheduled">Not Scheduled</div>;
    default:
      break;
  }
  return;
};

export const renderInterviewStatus = (status) => {
  switch (status) {
    case 1:
      return <div className="badge-r1 interview-status-badge">Round-1</div>;
    case 2:
      return <div className="badge-s interview-status-badge">Selected</div>;
    case 3:
      return <div className="badge-sh interview-status-badge">Shortlisted</div>;
    case 4:
      return (
        <div className="badge-re interview-status-badge">Not Selected</div>
      );
    case 5:
      return <div className="badge-oh interview-status-badge">On hold</div>;
    case 6:
      return <div className="badge-ns interview-status-badge">No show</div>;
    case 7:
      return (
        <div className="badge-w interview-status-badge">Withdraw candidate</div>
      );
    case 8:
      return (
        <div className="badge-ps interview-status-badge">Pre screened</div>
      );
    case 9:
      return <div className="badge-rs interview-status-badge">Rescheduled</div>;
    case 10:
      return <div className="badge-j interview-status-badge">Joined</div>;
    case 11:
      return <div className="badge-psr interview-status-badge">Ready For Pre-Screening</div>;
    default:
      break;
  }
  return;
};

export const formatDate = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return isoDate;
  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits for the day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear(); // Get the full year
  return `${day}-${month}-${year}`;
};

export const formatDateTime = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return isoDate;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  const hoursStr = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hoursStr}:${minutes} ${ampm}`;
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat("en-IN").format(number);
};

export const isFilterEmpty = (obj) => {
  return Object.entries(obj).every(([key, val]) => {
    if (key === "searchText") {
      return !val || val.trim() === "";
    }

    if (Array.isArray(val)) {
      return val.length === 0;
    }

    return val == null;
  });
};

export const formatToLPA = (value) => (value / 100000).toFixed(2);

export const calculateRange = (years, months) => {
  const startYear = years;
  const endYear = months > 0 ? years + 1 : years;
  return `${startYear} - ${endYear} years`;
};

export const getTokenInCookies = async () => {
  const cookies = document.cookie.split("; ");
  const tokenCookie = cookies.find((row) => row.startsWith("token="));

  if (!tokenCookie) {
    console.error("Token not found in cookies");
    return null;
  }

  return tokenCookie.split("=")[1];
};

export const renderCandidateFeedbackStatus = (status) => (
  <div
    style={{
      display: "inline-block",
      padding: "3px 8px",
      borderRadius: "20px",
      fontSize: "12px",
      backgroundColor:
        candidatesStatusList.statusBadge[status]?.background || "#fff",
      color: candidatesStatusList.statusBadge[status]?.borderText || "#000",
      border: `1px solid ${candidatesStatusList.statusBadge[status]?.borderText || "#000"
        }`,
    }}
  >
    {candidateStatusOption.emailtext[status] || "Unknown"}
  </div>
);

export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp;
    const now = Date.now() / 1000;
    return now >= exp;
  } catch (e) {
    return true;
  }
};

export const parsePossibleDate = (input) => {
  if (!input) return null;

  if (dayjs.isDayjs(input)) {
    return input.isValid() ? input : null;
  }

  const cleanedInput = typeof input === "string"
    ? input.trim().replace(/[/\\,-]+$/, "")
    : input;

  if (!cleanedInput) return null;

  const dateFormats = [
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "MM-DD-YYYY",
    "YYYY/MM/DD",
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "D MMM YYYY",
    "DD MMM YYYY",
    "D MMMM YYYY",
    "DD MMMM YYYY",
    "Do MMM YYYY",
    "Do MMMM YYYY",
    "MMMM D, YYYY",
    "MMMM Do, YYYY",
    "MMM D, YYYY",
    "MMM Do, YYYY",
    "Do MMM",
    "Do MMMM",
    "D MMM",
    "D MMMM",
    "DD/MM",
    "DD-MM",
  ];

  for (const format of dateFormats) {
    const parsed = dayjs(cleanedInput, format, true); // strict mode
    if (parsed.isValid()) return parsed;
  }

  // Fallback to dayjs standard parsing
  const dayjsParsed = dayjs(cleanedInput);
  if (dayjsParsed.isValid()) return dayjsParsed;

  // Fallback to native Date parse
  const dateObj = new Date(cleanedInput);
  if (!isNaN(dateObj.getTime())) {
    const fallback = dayjs(dateObj);
    if (fallback.isValid()) return fallback;
  }

  return null;
};

export const normalizeQuillValue = (value) => {
  if (!value) return "";

  const isEmpty = value.replace(/<(.|\n)*?>/g, "").trim().length === 0;
  return isEmpty ? "" : value;
};

export const getFileType = (fileName) => {
  if (!fileName) return "";
  const ext = fileName.split(".").pop().toLowerCase(); // get last part after "."
  return fileTypes[ext] || "application/octet-stream"; // default if not found
};

export const base64ToBlob = (base64, contentType = "") => {
  const cleanedBase64 = base64.replace(/^data:.*;base64,/, "");
  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

export const transformResumeObj = (obj) => {
  const apiData = { ...obj };
  if (apiData.objectid) {
    apiData["objectid_contact@odata.bind"] = apiData.objectid;
    delete apiData.objectid;
  }
  return apiData;
};

export const getInitials = (name = "") =>
  name
    ?.trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");


export const getColor = (s) => {
  if (s >= 70) return "#00B50C";
  if (s >= 60) return "#F8C22D";

  return "#E44A4C";
};

export const calculateRoundNumbers = (roundsList = []) => {
  if (!roundsList || roundsList.length === 0) return [];
  const roundNumbers = [];
  let currentRound = 1;
  for (let i = 0; i < roundsList.length; i++) {
    if (i === 0) {
      roundNumbers.push(1);
    } else {
      const prevRound = roundsList[i - 1];
      const prevStatus = Number(prevRound?.itl_status);
      if (prevStatus === 9) {
        roundNumbers.push(currentRound);
      } else {
        currentRound += 1;
        roundNumbers.push(currentRound);
      }
    }
  }
  return roundNumbers;
};

